import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';
import { DefaultModal } from '@frontend/modal';
import { LuLanguages } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import useLanguageSelectModal, { LanguageSelectModalProps } from './language-select-modal.controller';

const ID = 'language-select-modal';
export type { LanguageSelectModalProps };

const LanguageSelectModal = (props: LanguageSelectModalProps) => {
    const viewProps = useLanguageSelectModal(props);

    return (
        <DefaultModal
            id={ID}
            handleClose={props.onClose}
            className='bg-background-surface!'
            show={true}>
            <div className='card-header rounded-3 m-0 flex flex-row items-center p-3'>
                <LuLanguages className='me-2 size-6' />
                <div className='text-foreground-default text-xl font-semibold'>{CommonMessage.FORMS.LANGUAGE}</div>
            </div>
            <div className='card-body flex w-full flex-col items-start justify-start gap-3 p-3'>
                <div className='flex max-h-[50vh] w-full flex-col gap-2 overflow-auto'>
                    {viewProps.options ? (
                        viewProps.options.map((lang) => (
                            <div
                                key={lang.value}
                                onClick={() => viewProps.setSelected(lang)}
                                className='bg-background-default inline-flex h-16 w-full items-center justify-start gap-3 self-stretch rounded-2xl p-3'>
                                <div>
                                    {viewProps.selected?.value === lang.value ? (
                                        <div className='relative h-4 w-4'>
                                            <div className='border-border-default bg-background-default absolute top-0 left-0 h-4 w-4 rounded-full border' />
                                            <div className='bg-brand-primary absolute top-[3px] left-[3px] size-2.5 rounded-full' />
                                        </div>
                                    ) : (
                                        <div className='relative h-4 w-4'>
                                            <div className='border-border-default bg-background-default absolute top-0 left-0 h-4 w-4 rounded-full border' />
                                        </div>
                                    )}
                                </div>
                                <div className='flex items-center justify-start gap-2'>
                                    <div className='inline-flex h-full flex-col items-start justify-center gap-0.5'>
                                        <div className='text-foreground-default justify-start text-base font-semibold'>{lang.displayName}</div>
                                        <div className='justify-start text-sm font-medium text-neutral-600'>
                                            {viewProps.currentLocale === lang.value && (
                                                <FormattedMessage
                                                    id='current'
                                                    defaultMessage='Current'
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <Spinner />
                    )}
                </div>
            </div>
            <div className='card-footer flex w-full p-3'>
                <button
                    disabled={viewProps.submitDisabled}
                    onClick={() => viewProps.onSubmit()}
                    data-variant='Primary'
                    data-testid='update-language-button'
                    className={
                        'text-background-surface rounded-lg px-4 py-2.5 text-base font-medium ' +
                        (viewProps.submitDisabled ? 'bg-brand-disabled cursor-not-allowed' : 'bg-brand-primary hover:bg-brand-secondary cursor-pointer')
                    }>
                    <FormattedMessage
                        id='profile.language-select.update-language'
                        defaultMessage='Update language'
                        description='update language button on language select page'
                    />
                </button>
            </div>
        </DefaultModal>
    );
};

export default LanguageSelectModal;
